import React from 'react';
import './WelcomePage.css';
import milmaLogo from '../assets/milmalogo.png';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt, faBoxOpen, faCalendarCheck, faChartLine } from '@fortawesome/free-solid-svg-icons';

const WelcomePage = () => {
    return (
        <div className="welcome-container">
            <div className="overlay"></div>
            <div className="content-wrapper">
                <div className="welcome-card animate-fade-in">
                    
                    {/* Brand Section */}
                    <div className="brand-section text-center">
                        <img src={milmaLogo} alt="Milma Logo" className="milma-logo" />
                        <p className="tagline">കേരളം കണികണ്ടുണരുന്ന നന്മ</p>
                    </div>

                    {/* Hero / Login Call to Action */}
                    <div className="hero-section text-center">
                        <h2 className="welcome-title">Franchise Partner Portal</h2>
                        <p className="welcome-subtitle">
                            Secure access to your inventory, orders, and financial reports.
                        </p>
                        
                        <div className="action-area mt-4">
                            <Link to="/login" className="btn btn-milma-primary btn-lg w-100">
                                <FontAwesomeIcon icon={faSignInAlt} className="me-2" />
                                Login to Portal
                            </Link>
                        </div>
                    </div>

                    {/* Quick Feature Highlights (Simplified) */}
                    <div className="features-grid">
                        <div className="feature-item">
                            <div className="icon-circle">
                                <FontAwesomeIcon icon={faBoxOpen} />
                            </div>
                            <span>Stock</span>
                        </div>
                        <div className="feature-item">
                            <div className="icon-circle">
                                <FontAwesomeIcon icon={faCalendarCheck} />
                            </div>
                            <span>Orders</span>
                        </div>
                        <div className="feature-item">
                            <div className="icon-circle">
                                <FontAwesomeIcon icon={faChartLine} />
                            </div>
                            <span>Reports</span>
                        </div>
                    </div>
                    
                    <div className="footer-text text-center">
                        <small>&copy; {new Date().getFullYear()} Milma ERP. All rights reserved.</small>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default WelcomePage;